export async function toteShowUseCase(id, toteRepository) {
    const result = await toteRepository.show(id);

    const entity = new toteRepository.model(result);
    
    if (!entity.isValid()) {
        throw new Error("tote inválido");
    }

    return entity;
}